import React from 'react';

/**
 * The product wordmark.
 *
 * Three spans rather than one string on purpose: the alternating weight IS the
 * mark. It is the product's name - the same one on the App Store listing - so
 * it is deliberately never run through t().
 *
 * It lives in its own component because it is now drawn in two places (the
 * footer under every page, and the onboarding header). Two copies of a brand
 * mark drift apart the first time someone retouches one of them.
 */
export default function Wordmark({ className = 'text-[22px]' }) {
  return (
    <div className={`${className} leading-none tracking-tight select-none`}>
      <span className="font-bold text-gray-500">Zon</span>
      <span className="font-normal text-gray-400">Staff</span>
      <span className="font-bold text-gray-500">Management</span>
    </div>
  );
}
